import React, { useEffect, useState, useCallback } from "react";
import "./EnrollForm.css";
import Header from "./header/header";
import Footer from "./Footer";
import { useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import { usePaystackPayment } from "react-paystack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { loadStripe } from "@stripe/stripe-js";
import { ClipLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { BsEmojiFrown } from "react-icons/bs";
import {
  baseUrl,
  getUserCountry,
  PopulateContext,
  getDiscountPercentage,
} from "../App";
import { useCourses } from "./Contexts/CoursesContext";
import { useUsers } from "./Contexts/UsersContext";
import { useEnrollee } from "./Contexts/EnrolleeContext";
import ReactGA from "react-ga4";
import {
  ICourseDetails,
  IUserDetails,
  ICourseRegistration,
} from "./EnrollTypes";
import axios from "axios";

const NewEnrollForm: React.FC = () => {
  const { Enrollee, setEnrolleeContext } = useEnrollee();
  const { courses, setCoursesContext } = useCourses();
  const { User, setUserContext, setUsersContext } = useUsers();
  let location = useLocation();
  const [ready, setReady] = useState(false);
  const [user, setUser] = useState<IUserDetails>();
  const [Course, setCourse] = useState<ICourseDetails>();
  const [EnrolledUser, setEnrolledUser] = useState<ICourseRegistration>();
  const [courseName, setCourseName] = useState("");
  const [hidePayment, setHidePayment] = useState(false);
  const [showfirstinstallbtn, setShowfirstinstallbtn] = useState(true);
  const [showsecondinstallbtn, setShowsecondinstallbtn] = useState(false);
  const [showManualTransfer, setShowManualTransfer] = useState(false);
  const [currencyName, setCurrencyName] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [coursePayablePrice, setCoursePayablePrice] = useState(0);
  const [firstInstallmentRate, setFirstInstallmentRate] = useState(0.7);
  const [secondInstallmentRate, setSecondInstallmentRate] = useState(0.3);
  const [courseFirstInstallmentPayment, setCourseFirstInstallmentPayment] =
    useState(0);
  const [courseSecondInstallmentPayment, setCourseSecondInstallmentPayment] =
    useState(0);
  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");
  const [shownotification, setShowNotification] = React.useState(false);
  const [notification, setnotification] = React.useState("");
  const [showfirstinstall, setShowfirstinstall] = useState(true);
  const [EnrolledUserId, setEnrolledUserId] = useState("");
  const [hideInstallment, setHIdeInstallment] = useState(false);
  const [promoCodeMessageColor, setPromoCodeMessageColor] = useState("#FFFFFF");
  const [promoCodeMessage, setPromoCodeMessage] = useState(
    "Code incorrect or expired!"
  );
  const [PromoCodes, setPromoCodes] = useState<any>();
  const [inputedCode, setInputedCode] = useState("");
  const [promoApplied, setPromoApplied] = useState(false);
  const [disablePromoCodeButton, setDisablePromoCodeButton] = useState(false);
  const [fullCoursePrice, setFullCoursePrice] = useState(0);
  const [courseDiscount, setCourseDiscount] = useState(0);
  const shownote = false;
  const notific = "";
  const goodnote = false;

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent("");
  };
  const handleCloseNotification = () => {
    setShowNotification(false);
  };
  let params: any = useParams();
  let navigate = useNavigate();
  // const courseId = params["ids"];
  const courseSlug = params["slug"];

  const getCourseandUserData = useCallback(
    async (courseSlug: string, userId: string) => {
      try {
        if (User) {
          setUser(User);
        } else {
          const value = await PopulateContext("Users");
          if (value) {
            const _users = value.filter((each: any) => each.id === userId);
            setUser(_users[0]);
            setUsersContext(value);
            setUserContext(_users[0]);
          }
        }

        if (courses) {
          // let value: any = courses?.filter((each: any) => each.id === courseId);
          let value: any = courses?.filter(
            (each: any) =>
              each.CourseName &&
              each.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") === courseSlug
          );
          setCourse(value[0]);
        } else {
          const value = await PopulateContext("Courses");
          if (value) {
            const _course: any = value?.filter(
            (each: any) =>
              each.CourseName &&
              each.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") === courseSlug
          );
            setCourse(_course[0]);
            const newValue = value.filter(
              (each: any) =>
                each.isDeleted === false && each.isArchive === false
            );
            setCoursesContext(newValue);
          }
        }

        if (Enrollee) {
          let value: any = Enrollee?.filter(
            (each: any) =>
              each?.email === user?.email && each?.course === Course?.CourseName
          );
          if (value[0]) {
            const EnrolledUser = value[0];
            setEnrolledUser(EnrolledUser);
            if (EnrolledUser?.status !== "Enrolled") {
              console.log(promoApplied);
              if(!promoApplied){setCoursePayablePrice(EnrolledUser?.coursePrice);}
              setCourseFirstInstallmentPayment(EnrolledUser?.paidPrice);
              setEnrolledUserId(EnrolledUser?.id);
              setCourseSecondInstallmentPayment(
                EnrolledUser?.coursePrice - EnrolledUser?.paidPrice
              );
              setDisablePromoCodeButton(true);
              setShowsecondinstallbtn(true);
              setShowfirstinstallbtn(false);
              setShowfirstinstall(false);
            }
            else{setHidePayment(true);}
          }
        } else {
          const value = await PopulateContext("Enrollees");
          const _enrollees: any = value?.filter(
            (each: any) =>
              each?.email === user?.email && each?.course === Course?.CourseName
          );
          setEnrolleeContext(value);
          const EnrolledUser = _enrollees[0];
          setEnrolledUser(EnrolledUser);
          if (EnrolledUser?.status !== "Enrolled") {
            console.log(promoApplied);
            if(!promoApplied){setCoursePayablePrice(EnrolledUser?.coursePrice)};
            setCourseFirstInstallmentPayment(EnrolledUser?.paidPrice);
            setEnrolledUserId(EnrolledUser?.id);
            setCourseSecondInstallmentPayment(
              EnrolledUser?.coursePrice - EnrolledUser?.paidPrice
            );
            setDisablePromoCodeButton(true);
            setShowsecondinstallbtn(true);
            setShowfirstinstallbtn(false);
            setShowfirstinstall(false);
          }
          else{setHidePayment(true);}
        }
      } catch (error: any) {
        console.log("There is an error getting user details and course data");
        setShowModal(true);
        setModalContent("Could not fetch needed information.");
      }
    },
    [
      Course,
      user,
      Enrollee,
      User,
      courses,
      promoApplied,
      setUserContext,
      setUsersContext,
      setCoursesContext,
      setEnrolleeContext,
    ]
  );


  const InitialSetups = useCallback(async () => {
    const userDetails = await getUserCountry();
    let price = 0;
    if (Course && user) {
      if (
        user.scholarshipRecipient === true &&
        user.scholarshipUsed === false
      ) {
        setShowNotification(true);
        setnotification(
          "Congratulations! You have been awarded a scholarship of " +
            user.scholarshipDiscount +
            "% for the " +
            Course.CourseName +
            " course. Please proceed to make payment of outstanding fees!"
        );
      }

      switch (userDetails.continentCode) {
        case "EU":
          if (userDetails?.countryCode === "GB") {
            // setUserCurrency("£");
            setCurrencyName("gbp");
            setCurrencySymbol("£");
            price = Course?.Price?.priceInEuros;
            setShowManualTransfer(false); //Disabling information display for transferring money manually.
          } else {
            setCurrencyName("eur");
            setCurrencySymbol("€");
            price = Course?.Price?.priceInEuros;
            setShowManualTransfer(false); //Disabling information display for transferring money manually.
          }
          break;
          
        case "AF":
          if (userDetails.countryCode === "NG") {
            setCurrencyName("Naira");
            setCurrencySymbol("₦");
            price = Course?.Price?.priceInNaira * 1000;
            setShowManualTransfer(true);
          } else {
            setCurrencyName("usd");
            setCurrencySymbol("$");
            price = Course?.Price?.priceForOtherAfricans;
            setShowManualTransfer(false);
          }
          break;
        default:
          setCurrencyName("usd");
          setCurrencySymbol("$");
          price = Course?.Price?.priceInDollars;
          setShowManualTransfer(false);
      }
      setCourseName(Course?.CourseName);
      //The following sets of conditions calculate the price payable based on different discounts achievable
      if (price && Course) {
        setFullCoursePrice(price);
        if (Course.showDiscount) {
          setCourseDiscount(Course?.discount);
        }
      }
      let coursepayable: number = 0;
      if (Course?.discount >= 40) {
        setFirstInstallmentRate(0.85);
        setSecondInstallmentRate(0.15);
      }
      if (EnrolledUser) {
        price = EnrolledUser?.coursePrice;
        coursepayable = EnrolledUser?.coursePrice;
        setCoursePayablePrice(coursepayable);
        setCourseFirstInstallmentPayment(EnrolledUser?.paidPrice);
        setCourseSecondInstallmentPayment(EnrolledUser?.coursePrice - EnrolledUser?.paidPrice);
        setCourseDiscount(0);
        setDisablePromoCodeButton(true);
        if (userDetails.countryCode === "NG" && coursepayable <= 200000) {
          setHIdeInstallment(true);
        }
        if (coursepayable <= 100) {
          setHIdeInstallment(true);
        }
      } else {
        if (
          Course.showDiscount === true &&
          user?.scholarshipRecipient === true &&
          user?.scholarshipUsed === false
        ) {
          coursepayable = Math.round(
            price -
              (Course.discount * price) / 100 -
              (user.scholarshipDiscount * price) / 100
          );
          if (coursepayable < 1) {
            setHidePayment(true);
          }
          if(!promoApplied){setCoursePayablePrice(coursepayable);}
        }
        if (
          Course.showDiscount === false &&
          user?.scholarshipRecipient === true &&
          user?.scholarshipUsed === false
        ) {
          coursepayable = Math.round(
            price - (user.scholarshipDiscount * price) / 100
          );
          if (coursepayable < 1) {
            setHidePayment(true);
          }
          if(!promoApplied){setCoursePayablePrice(coursepayable)}
        }
        if (
          Course.showDiscount === true &&
          user?.scholarshipRecipient === false &&
          user?.scholarshipUsed === false
        ) {
          coursepayable = Math.round(price - (Course.discount * price) / 100);
          if (coursepayable < 1) {
            setHidePayment(true);
          }
          if(!promoApplied){setCoursePayablePrice(coursepayable)};
        }
        if (
          Course.showDiscount === false &&
          user?.scholarshipRecipient === false &&
          user?.scholarshipUsed === false
        ) {
          coursepayable = Math.round(price);
          if (coursepayable < 1) {
            setHidePayment(true);
          }
          if(!promoApplied){setCoursePayablePrice(coursepayable);}
        }

        if(!EnrolledUserId){
        setCourseFirstInstallmentPayment(
          Math.round(coursepayable * firstInstallmentRate)
        );
        setCourseSecondInstallmentPayment(
          Math.round(coursepayable * secondInstallmentRate)
        );
      }
        if (userDetails.countryCode === "NG" && coursepayable <= 200000) {
          setHIdeInstallment(true);
        }
        if (coursepayable <= 100) {
          setHIdeInstallment(true);
          setDisablePromoCodeButton(true);
        }
      }
      const { promoActive } = await getDiscountPercentage();
      if (promoActive) {
        setHIdeInstallment(true);
        setDisablePromoCodeButton(true);
      }
      setReady(true);
    }
  }, [Course, user, EnrolledUser, promoApplied, firstInstallmentRate, secondInstallmentRate, EnrolledUserId]);

  useEffect(() => {
    const fetch = async () => {
      let userId = localStorage.getItem("UserId");
      const idToken = localStorage.getItem("idToken");
      if (User && !userId) {
        userId = User?.id;
      }
      if (!userId || !User) {
        navigate("/signin", { state: { from: location.pathname } });
        return;
      }
      await getCourseandUserData(courseSlug, userId);
      await InitialSetups();
      try {
        const getPromoCodes = await axios.get(`${baseUrl}/promo`, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        });
        setPromoCodes(getPromoCodes?.data?.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetch();
  }, [
    courseSlug,
    getCourseandUserData,
    location.pathname,
    navigate,
    InitialSetups,
    User,
  ]);

  const computeAmountToPay = async () => {
    console.log("Inputed code");
    console.log(inputedCode);
    if (inputedCode.length < 7) {
      setPromoCodeMessageColor("#FF0000");
      setPromoCodeMessage("Code incorrect or expired!");
      return;
    }
    
    let allPromoCodes = PromoCodes?.PromoCodes;
    console.log(allPromoCodes)
    let ifInputedCodeExists = allPromoCodes.filter((each: any) => each.Code === inputedCode);
    if (ifInputedCodeExists.length>0 && Course) {
      setPromoCodeMessage("Promo Code Applied!");
      setPromoCodeMessageColor("#0f520e");
      console.log(coursePayablePrice, ifInputedCodeExists[0].DiscountValue);
      setCoursePayablePrice(coursePayablePrice * (1 - ifInputedCodeExists[0].DiscountValue * 0.01));
      setCourseDiscount(ifInputedCodeExists[0].DiscountValue);
      setHIdeInstallment(true);
      setPromoApplied(true)
      setDisablePromoCodeButton(true);
      return;
    }
    const { promoActive } = await getDiscountPercentage();
    if (promoActive && Course) {
      if (
        (inputedCode === "BLACKFRIDAY" || inputedCode === "blackfriday") &&
        PromoCodes?.BLACKFRIDAY > 0
      ) {
        setPromoCodeMessage("Promo Code Applied!");
        setPromoCodeMessageColor("#0f520e");
        setCoursePayablePrice(
          coursePayablePrice * (1 - Course?.discount * 0.01)
        );
        setCourseDiscount(Course?.discount);
        setPromoApplied(true);
        setHIdeInstallment(true);
        setDisablePromoCodeButton(true);
        return;
      }
    }

    setPromoCodeMessageColor("#FF0000");
    setPromoCodeMessage("Code incorrect or expired!");
    return;
  };

  const firstinstallments = () => {
    setShowfirstinstall(!showfirstinstall);
  };

  const secondinstallments = () => {
    setShowfirstinstall(!showfirstinstall);
  };

  const freeTier = async () => {
    const userData = {
      PromoCodeRecipient: disablePromoCodeButton,
      inputedPromoCode: inputedCode,
      DeadlineValue: 0,
      HasDeadline: false,
      coursePrice: coursePayablePrice,
      paidPrice: 0,
      paymentCurrency: currencySymbol,
      paymentPercentage: 100,
      course: courseName,
      email: user?.email,
      firstname: user?.firstname,
      lastname: user?.lastname,
      phone: user?.phone,
      sourceOfDiscovery: user?.sourceOfDiscovery,
      status: "Enrolled",
      paymentType: "full",
      scholarshipRecipient: user?.scholarshipRecipient,
      scholarshipUsed: user?.scholarshipUsed,
      enrolledUserId: EnrolledUserId,
      userId: user?.id,
      Referred: user?.Referred,
      FullCoursePrice: fullCoursePrice,
      CourseDiscount: courseDiscount,
      AmountCharged: 0,
      AmountPaid: 0, // THIS VALUE IS PUT THERE TO TRACK REFERRAL CALCULATIONS
    };
    sessionStorage.setItem("enroll-form-dataform", JSON.stringify(userData));
    navigate("/enrollformsuccess");
  };

  const onSuccess: any = (
    status: string,
    value: number,
    paymentDetail: string
  ) => {
    let newValue = value;
    let deadline = 0;
    let hasdeadline = false;
    if (paymentDetail === "secondinstallment") {
      newValue = coursePayablePrice;
      deadline = 0;
      hasdeadline = false;
    }
    if (paymentDetail === "firstinstallment") {
      deadline = 42;
      hasdeadline = true;
    }
    const userData = {
      PromoCodeRecipient: disablePromoCodeButton,
      inputedPromoCode: inputedCode,
      DeadlineValue: deadline,
      HasDeadline: hasdeadline,
      coursePrice: coursePayablePrice,
      paidPrice: newValue,
      paymentCurrency: currencySymbol,
      paymentPercentage: Math.round((newValue / coursePayablePrice) * 100),
      course: courseName,
      email: user?.email,
      firstname: user?.firstname,
      lastname: user?.lastname,
      phone: user?.phone,
      sourceOfDiscovery: user?.sourceOfDiscovery,
      status: status,
      paymentType: paymentDetail,
      scholarshipRecipient: user?.scholarshipRecipient,
      scholarshipUsed: user?.scholarshipUsed,
      enrolledUserId: EnrolledUserId,
      userId: user?.id,
      Referred: user?.Referred,
      FullCoursePrice: fullCoursePrice,
      CourseDiscount: courseDiscount,
      AmountCharged: value,
      AmountPaid: value, //THIS VALUE IS PUT THERE TO TRACK REFERRAL CALCULATIONS
    };
    sessionStorage.setItem("enroll-form-dataform", JSON.stringify(userData));
    navigate("/enrollformsuccess");
  };
  const onClose = () => {
    sessionStorage.removeItem("enroll-form-dataform");
    navigate("/enrollformcancel");
  };

  //PAYMENT BEGINS HERE
  const priceSplitter = (number: any) =>
    number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  interface PaymentProps {
    paymentDetail: string;
  }

  var publickey: any = process.env.REACT_APP_PAYSTACKPUBLIC_KEY;

  const PaystackHookExample = ({ paymentDetail }: PaymentProps) => {
    // This section is for analytics.
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
    });
    ReactGA.event({
      category: "Payments",
      action: "Making Payment",
      label: "Customers who clicked on the 'Pay Now' button.",
    });
    //

    let value = 0;
    let status = "";
    if (paymentDetail === "full") {
      status = "Enrolled";
      value = coursePayablePrice;
    }
    if (paymentDetail === "firstinstallment") {
      status = "Partial-payment";
      value = courseFirstInstallmentPayment;
    }
    if (paymentDetail === "secondinstallment") {
      status = "Enrolled";
      value = courseSecondInstallmentPayment;
    }
    // if(value <= 0){return}
    const paystackConfig = {
      reference: new Date().getTime().toString(),
      email: user?.email || "",
      amount: value * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
      publicKey: publickey,
    };
    const initializePayment = usePaystackPayment(paystackConfig);
    return (
      <div>
        <div
          style={{
            backgroundColor: "#156614",
            height: "50px",
            borderRadius: "20px",
            marginTop: "10px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="flash"
          onClick={() => {
            initializePayment(
              () => onSuccess(status, value, paymentDetail),
              onClose
            );
          }}
        >
          <img
            style={{ marginLeft: "15%", padding: "10px", height: "50px" }}
            src="../../images/paystacklogo.png"
            alt="googles"
          />
        </div>
      </div>
    );
  };

  const makePaymentWithStripe = async (paymentType: string) => {
    // This section is for analytics.
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
    });
    ReactGA.event({
      category: "Payments",
      action: "Making Payment",
      label: "Customers who clicked on the 'Pay Now' button.",
    });
    //
    const stripe: any = await loadStripe(
      String(process.env.REACT_APP_STRIPEPK_LIVEKEY)
    );

    let value = 0;
    let status = "";
    let deadline = 0;
    let hasdeadline = false;

    if (paymentType === "full") {
      status = "Enrolled";
      value = coursePayablePrice;
    }
    if (paymentType === "firstinstallment") {
      status = "Partial-payment";
      value = courseFirstInstallmentPayment;
      deadline = 42;
      hasdeadline = true;
    }
    if (paymentType === "secondinstallment") {
      status = "Enrolled";
      value = courseSecondInstallmentPayment;
      hasdeadline = false;
      deadline = 0;
    }
    if (value <= 0) {
      return;
    }
    const body = {
      packages: [
        {
          program: "Course Payment",
          name: courseName,
          price: String(value),
          image:
            "https://st.depositphotos.com/2890953/4530/i/950/depositphotos_45303419-stock-photo-books-and-graduation-cap.jpg",
          currency: String(currencyName),
        },
      ],
      successUrl: process.env.REACT_APP_API_STRIPE_SUCCESS_URL,
      cancelUrl: process.env.REACT_APP_API_STRIPE_FAILURE_URL,
    };

    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(`${baseUrl}/create-checkout-session`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });
    let newValue = value;
    if (paymentType === "secondinstallment") {
      newValue = coursePayablePrice;
    }
    const userData = {
      PromoCodeRecipient: disablePromoCodeButton,
      inputedPromoCode: inputedCode,
      DeadlineValue: deadline,
      HasDeadline: hasdeadline,
      coursePrice: coursePayablePrice,
      paidPrice: newValue,
      paymentCurrency: currencySymbol,
      paymentPercentage: Math.round((newValue / coursePayablePrice) * 100),
      course: courseName,
      email: user?.email,
      firstname: user?.firstname,
      lastname: user?.lastname,
      phone: user?.phone,
      sourceOfDiscovery: user?.sourceOfDiscovery,
      status: status,
      paymentType: paymentType,
      scholarshipRecipient: user?.scholarshipRecipient,
      scholarshipUsed: user?.scholarshipUsed,
      enrolledUserId: EnrolledUserId,
      userId: user?.id,
      Referred: user?.Referred,
      FullCoursePrice: fullCoursePrice,
      CourseDiscount: courseDiscount,
      AmountCharged: courseSecondInstallmentPayment,
      AmountPaid: value, //THIS VALUE IS PUT THERE TO TRACK REFERRAL CALCULATIONS
    };
    const session = await response.json();
    sessionStorage.setItem("enroll-form-dataform", JSON.stringify(userData));
    sessionStorage.setItem("sessiontrackidss", session.id);
    const result = stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      console.log(result.error);
    }
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>
      <Modal show={shownotification} centered={true}>
        <Modal.Body style={{ marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {notification}
            <div style={{ marginTop: "1rem" }}>
              <button
                onClick={handleCloseNotification}
                style={{
                  backgroundColor: "#047E35",
                  color: "white",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.25rem",
                  cursor: "pointer",
                  border: "none",
                  marginRight: "1rem",
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {ready ? (
        <>
          <Header />

          {goodnote ? (
            <>
              <div
                className={
                  shownote
                    ? "text-center shownotenroll"
                    : "text-center hidenotenroll"
                }
              >
                <div>
                  <FontAwesomeIcon
                    style={{ display: "inline", fontSize: "25px" }}
                    icon={faCheck}
                  />
                  <h3 style={{ marginLeft: "10px", display: "inline" }}>
                    {notific}
                  </h3>
                </div>
              </div>

              {shownote ? (
                <>
                  <br />
                  <br />
                  <br />
                  <br />
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <>
              <div
                className={
                  shownote
                    ? "text-center shownot2enroll"
                    : "text-center hidenot2enroll"
                }
              >
                <div>
                  <FontAwesomeIcon
                    style={{ display: "inline", fontSize: "25px" }}
                    icon={faXmark}
                  />
                  <h3 style={{ marginLeft: "10px", display: "inline" }}>
                    {notific}
                  </h3>
                </div>
              </div>

              {shownote ? (
                <>
                  <br />
                  <br />
                </>
              ) : (
                <></>
              )}
            </>
          )}

          <div>
            <div
              className="container Enroll-page"
              style={{ marginTop: "20px" }}
            >
              <div className="Enroll-top">
                <div className="row">
                  <div className="col-md-4">
                    <div className="row firstcontent">
                      <h4 style={{ fontWeight: "600" }}>
                        Unlock Your Potential:
                      </h4>
                      <h4 style={{ fontWeight: "600" }}>Enroll Today!</h4>
                      <p>Take the First Step Towards Your Bright Future</p>
                      <img
                        src="../../images/enrolloneimg.png"
                        alt="enrolimg"
                        style={{ width: "100%", height: "241px" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="secondcontent">
                      <div>
                        {hidePayment ? (
                          <>
                          {EnrolledUser && EnrolledUser?.status !== "Partial-payment" ? (
                            <>
                            <div>
                              <h2>
                                You have successfully enrolled and completed payment for this course.
                              </h2>
                            </div>
                            <div className="row">
                              <div className="col-md-3"></div>
                              <div className="col-md-6">
                                <button
                                  className="btn btn-success"
                                  onClick={() => {
                                    navigate('/profile');
                                  }}
                                >
                                  Go to Profile Page
                                </button>
                              </div>
                              <div className="col-md-3"></div>
                            </div>
                            </>
                            ) :(
                            <>
                            <div>
                              <h2>
                                This is a free plan. Please click the button
                                below to Enroll.
                              </h2>
                            </div>
                            <div className="row">
                              <div className="col-md-3"></div>
                              <div className="col-md-6">
                                <button
                                  className="btn btn-success"
                                  onClick={() => {
                                    freeTier();
                                  }}
                                >
                                  Click to Finish
                                </button>
                              </div>
                              <div className="col-md-3"></div>
                            </div>
                            </>)
                          }
                          </>
                        ) : (
                          <>
                            <h3
                              style={{
                                marginTop: "10px",
                                textAlign: "center",
                              }}
                            >
                              {courseName}
                            </h3>

                            <div className="flex flex-col items-end w-full gap-4 my-0">
                              <div className="flex gap-4 w-full justify-end">
                                <input
                                  type="text"
                                  className="textinputs p-2"
                                  placeholder="Promo code"
                                  onChange={(e) => {
                                    setInputedCode(e.target.value);
                                  }}
                                />
                                <button
                                  className="btn btn-success"
                                  onClick={computeAmountToPay}
                                  disabled={disablePromoCodeButton}
                                >
                                  Apply
                                </button>
                              </div>
                              <label style={{ color: promoCodeMessageColor }}>
                                {promoCodeMessage}
                              </label>
                            </div>

                            {!EnrolledUser && <div
                              style={{
                                backgroundColor: "#F5F5F5",
                                borderRadius: "10px",
                                width: "100%",
                              }}
                            >
                              <div className="container">
                                <div className="row">
                                  <div className="col-xl-6">
                                    <div
                                      style={{
                                        margin: "30px",
                                        marginTop: "50px",
                                      }}
                                    >
                                      <div
                                        className="text-center"
                                        style={{
                                          backgroundColor: "#0f520e",
                                          borderRadius: "5px",
                                          padding: "10px",
                                          marginTop: "50px",
                                        }}
                                      >
                                        <h5
                                          style={{
                                            color: "#ffffff",
                                            margin: "20px",
                                          }}
                                        >
                                          Payment
                                        </h5>

                                        <div
                                          style={{
                                            margin: "20px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <h5
                                            style={{
                                              color: "#ffffff",
                                              margin: "0 10px 0 0",
                                            }}
                                          >
                                            {currencySymbol}
                                          </h5>
                                          <h3
                                            style={{
                                              color: "#ffffff",
                                              margin: "0",
                                            }}
                                          >
                                            {priceSplitter(coursePayablePrice)}
                                          </h3>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-6">
                                    <div
                                      style={{
                                        marginTop: "30px",
                                        marginBottom: "30px",
                                      }}
                                    >
                                      <h4>Select Payment Method</h4>
                                      {/* I decided to use showManualTransfer since it also carries a boolean value determining the currency. */}
                                      {/* We don't need to create a new state for isCurrencyNaira */}
                                      {showManualTransfer ? (
                                        <>
                                          <PaystackHookExample paymentDetail="full" />
                                        </>
                                      ) : (
                                        <>
                                          <div
                                            style={{
                                              background: "#277a8f",
                                              padding: "9px",
                                              borderRadius: "10px",
                                              cursor: "pointer",
                                              textAlign: "center",
                                              marginTop: "10px",
                                              color: "#ffffff",
                                              fontSize: "17px",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                            className="flash"
                                            onClick={() => {
                                              makePaymentWithStripe("full");
                                            }}
                                          >
                                            <span>Pay Now with</span>
                                            <img
                                              src="../../images/Stripepay.png"
                                              alt="stripe"
                                              style={{
                                                marginLeft: "8px",
                                                height: "30px",
                                              }}
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>}
                            {user?.scholarshipRecipient ? (
                              <></>
                            ) : (
                              <>
                                {hideInstallment ? (
                                  <></>
                                ) : (
                                  <>
                                    {!EnrolledUser && <p style={{ textAlign: "center" }}>Or</p>}
                                    {!EnrolledUser && <p style={{ textAlign: "center" }}>
                                      You can pay in installment:
                                    </p>}

                                    <div
                                      style={{
                                        border: "1px solid #767e7e",
                                        borderRadius: "10px",
                                        padding: "10px",
                                      }}
                                    >
                                      <div
                                        className="text-center"
                                        style={{
                                          fontWeight: "bold",
                                          marginBottom: "7px",
                                        }}
                                      >
                                        <div className="row">
                                          <div className="col-md-6">
                                            <div
                                              className={
                                                showfirstinstall
                                                  ? "activeenroll"
                                                  : "inactiveenroll"
                                              }
                                              onClick={firstinstallments}
                                            >
                                              First Installment
                                            </div>
                                          </div>

                                          <div className="col-md-6">
                                            <div
                                              className={
                                                showfirstinstall
                                                  ? "inactiveenroll"
                                                  : "activeenroll"
                                              }
                                              onClick={secondinstallments}
                                            >
                                              Second Installment
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <hr />
                                      {showfirstinstall ? (
                                        <>
                                          <div style={{ padding: "10px" }}>
                                            <div>
                                              <p style={{ fontWeight: "bold" }}>
                                                Pay in installments{" "}
                                              </p>
                                            </div>
                                            <div>
                                              <div className="row">
                                                <div className="col-6">
                                                  <p
                                                    style={{
                                                      display: "inline",
                                                    }}
                                                  >
                                                    Total Course Fee:
                                                  </p>
                                                </div>
                                                <div className="col-6">
                                                  <p
                                                    style={{
                                                      display: "inline",
                                                      float: "right",
                                                    }}
                                                  >
                                                    {currencySymbol +
                                                      priceSplitter(
                                                        coursePayablePrice
                                                      )}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              <div className="row">
                                                <div className="col-6">
                                                  <p
                                                    style={{
                                                      display: "inline",
                                                    }}
                                                  >
                                                    Your 1st installment Payment
                                                    is:
                                                  </p>
                                                </div>
                                                <div className="col-6">
                                                  <p
                                                    style={{
                                                      display: "inline",
                                                      float: "right",
                                                    }}
                                                  >
                                                    {/* //Here, display the 70% price */}
                                                    {currencySymbol +
                                                      priceSplitter(
                                                        courseFirstInstallmentPayment
                                                      )}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <hr />
                                            {showfirstinstallbtn ? (
                                              <>
                                                {showManualTransfer ? (
                                                  <>
                                                    <PaystackHookExample paymentDetail="firstinstallment" />
                                                  </>
                                                ) : (
                                                  <>
                                                    <div
                                                      style={{
                                                        background: "#277a8f",
                                                        padding: "9px",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                        textAlign: "center",
                                                        marginTop: "10px",
                                                        color: "#ffffff",
                                                        fontSize: "17px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                      }}
                                                      className="flash"
                                                      onClick={() => {
                                                        makePaymentWithStripe(
                                                          "firstinstallment"
                                                        );
                                                      }}
                                                    >
                                                      <span>Pay Now with</span>
                                                      <img
                                                        src="../../images/Stripepay.png"
                                                        alt="stripe"
                                                        style={{
                                                          marginLeft: "8px",
                                                          height: "30px",
                                                        }}
                                                      />
                                                    </div>
                                                  </>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <div className="text-center">
                                                  <button
                                                    className="btn btn-success"
                                                    disabled={true}
                                                  >
                                                    Please proceed to pay for
                                                    second installment
                                                  </button>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div style={{ padding: "10px" }}>
                                            <div>
                                              <p style={{ fontWeight: "bold" }}>
                                                Pay in installments{" "}
                                              </p>
                                            </div>
                                            <div>
                                              <div className="row">
                                                <div className="col-6">
                                                  <p
                                                    style={{
                                                      display: "inline",
                                                    }}
                                                  >
                                                    Total Course Fee:
                                                  </p>
                                                </div>
                                                <div className="col-6">
                                                  <p
                                                    style={{
                                                      display: "inline",
                                                      float: "right",
                                                    }}
                                                  >
                                                    {currencySymbol +
                                                      priceSplitter(
                                                        coursePayablePrice
                                                      )}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              <div className="row">
                                                <div className="col-6">
                                                  <p
                                                    style={{
                                                      display: "inline",
                                                    }}
                                                  >
                                                    Your 2nd installment Payment
                                                    is:
                                                  </p>
                                                </div>
                                                <div className="col-6">
                                                  <p
                                                    style={{
                                                      display: "inline",
                                                      float: "right",
                                                    }}
                                                  >
                                                    {currencySymbol +
                                                      priceSplitter(
                                                        courseSecondInstallmentPayment
                                                      )}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <hr />
                                            {showsecondinstallbtn ? (
                                              <>
                                                {showManualTransfer ? (
                                                  <>
                                                    <PaystackHookExample paymentDetail="secondinstallment" />
                                                  </>
                                                ) : (
                                                  <>
                                                    <div
                                                      style={{
                                                        background: "#277a8f",
                                                        padding: "9px",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                        textAlign: "center",
                                                        marginTop: "10px",
                                                        color: "#ffffff",
                                                        fontSize: "17px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                      }}
                                                      className="flash"
                                                      onClick={() => {
                                                        makePaymentWithStripe(
                                                          "secondinstallment"
                                                        );
                                                      }}
                                                    >
                                                      <span>Pay Now with</span>
                                                      <img
                                                        src="../../images/Stripepay.png"
                                                        alt="stripe"
                                                        style={{
                                                          marginLeft: "8px",
                                                          height: "30px",
                                                        }}
                                                      />
                                                    </div>
                                                  </>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <div className="text-center">
                                                  <button
                                                    className="btn btn-success"
                                                    disabled={true}
                                                  >
                                                    Please pay the first
                                                    installment
                                                  </button>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    {showManualTransfer ? (
                                      <>
                                        <p style={{ textAlign: "center" }}>
                                          Or
                                        </p>
                                        <p style={{ textAlign: "center" }}>
                                          You can forward Payment to:
                                        </p>

                                        <div
                                          style={{
                                            backgroundColor: "#F5F5F5",
                                            borderRadius: "10px",
                                            padding: "10px",
                                          }}
                                        >
                                          <p>Account Number: 1027328932</p>
                                          <p>
                                            Account Name: Doyenify Shop Pocket
                                          </p>
                                          <p>Bank: VFD Microfinance Bank</p>
                                          <p style={{ fontWeight: "bold" }}>
                                            Send Evidence of Payment to:{" "}
                                          </p>
                                          <p>
                                            {" "}
                                            Email address: info@doyenify.com
                                          </p>
                                          <p>
                                            {" "}
                                            or Whatsapp Numbers: +372 5670 4920, +372 5387 3078,
                                            +2347088096585{" "}
                                          </p>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            <div className="academystyle">
              <img
                src="../../images/doyenifyAcademy.png"
                alt="Doyenify academy"
              />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NewEnrollForm;
